import CountdownTimer from '../../../components/common/datetime/CountdownTimer';
import InfoToolTip from '../../../components/common/tooltip/InfoToolTip.jsx';
import MyCalendar from '../../../components/common/calendar/MyCalendar';
import Legend from '../../../components/containers/legendController';
import { useReportData } from '../../../hooks/data/useReportData.js';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import verifyToken from "../../../utils/tokenUtils.js";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import Cookies from 'js-cookie';
import './calendarview.css';

const CalendarView = () => {
  const navigate = useNavigate();
  const getAuthToken = () => { return Cookies.get('gtms-cp-auth'); };

  const {data: reportInfo,} = useReportData('report info', 20, { id: 15 });
  const infoRow = reportInfo?.data?.[0];
  const {data, refresh} = useReportData('dock appointment', 800);
  const calendarData = data?.data ?? [];
  console.log(calendarData)

  useEffect(() => { 
    const token = getAuthToken();
    token ? verifyToken(token) : navigate('/');
  }, []);

  useEffect(() => {
    const id = setInterval(refresh, 30 * 60 * 1000);
    return () => clearInterval(id);
  }, [refresh]);

  return (
    <div className='calendarPage'> 
      <div className="LandingPageContainer">
        <NavBar/>
        <Sidebar/>
        <div className="calendarPageContent">
          <div className="scoreBoardTitle">
            <h1>Dock Appointment</h1>
            {reportInfo && <InfoToolTip info={infoRow} />}
          </div>    
          <div className="dockApptSubHeader">
            <div className="deleveryApptLegend">
              <Legend type='EVENTLEGEND'/>
            </div>
            <div>
              <span>Auto-refresh in:</span>
              <span className='dockApptCountdownTimer'>
                <CountdownTimer duration={1800} />
              </span>
            </div>
            <div>
              <Button variant='outlined' size="small" onClick={refresh}>
                Refresh Calendar
              </Button>
            </div>
          </div>
          <div className="calendar"> 
           <MyCalendar data={calendarData}/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CalendarView